import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "./assets/fonts/font.css";
import i18n from "../src/config/localization";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import theme from "./config/theme";
import Router from "./config/routes";
import store from "config/redux/index";
import { Banner, PixelPageTracker, ScrollToTop } from "components";

function App() {
  return (
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <Notifications />
          <ScrollToTop />
          <Banner />
          <PixelPageTracker />
          <Router />
        </I18nextProvider>
      </MantineProvider>
    </Provider>
  );
}

export default App;
